import * as yup from "yup";

import { PHONE_NUMBER_REGEX } from "@constants";
import { Translations, i18n } from "@i18n";
import { PhoneNumberRouteFormValues } from "./types";

export const validationSchema: yup.SchemaOf<PhoneNumberRouteFormValues> = yup.object().shape({
  phoneNumber: yup
    .string()
    .required(i18n.t(Translations.PhoneNumberRoutePhoneNumberInputRequired))
    .matches(PHONE_NUMBER_REGEX, i18n.t(Translations.PhoneNumberRoutePhoneNumberInputInvalid)),
});
